import { Box, Icon, TextField, SxProps } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { stringToDate } from 'src/utils/date-utils';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';

type Props = {
    value: string | null,
    label: string,
    error?: boolean,
    onChange: (updatedValue: string | null) => void,
    sx?: SxProps
}

const NullableDatePicker = ({ value, onChange, label, error = false, sx }: Props) => {
    const { user } = useAuth();
    const [dateFormatError, setDateFormatError] = React.useState(false);
    const [internalDate, setInternalDate] = useState<Date | null>(null);
    const dateFormat = user?.dateFormat ?? 'M/D/YYYY';

    useEffect(() => {
        setInternalDate(stringToDate(value));
    }, [value])

    const onDateChange = (date: Date) => {
        setDateFormatError(false);

        try {
            const dateString = date.toISOString();
            setInternalDate(date);
            onChange(dateString);
        }
        catch (err) {
            setDateFormatError(true);
            //onChange(null)
        }
    }

    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <DesktopDatePicker label={label}
                inputFormat={dateFormat }
                value={internalDate}
                onChange={onDateChange}
                renderInput={(params) => <TextField {...params} sx={{ ...sx }} size='small' error={error || (dateFormatError && value !== null)} onBeforeInput={(e) => e.preventDefault()} />} />
            <Icon onClick={() => { onChange(null); setInternalDate(null); }} title="Clear Date">cancel</Icon>
        </Box>
    </LocalizationProvider>
}

export { NullableDatePicker }
export default NullableDatePicker